/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/itemgrideditor.ts" />
namespace TabAurous.Purchase {

    import fld = PurchaseItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.filterable()
    export class PurchaseItemsEditor extends _Ext.ItemGridEditor<PurchaseItemsRow> {
        protected getColumnsKey() { return "Purchase.PurchaseItems"; }
        protected getDialogType() { return PurchaseItemsDialog; }
        protected getLocalTextPrefix() { return PurchaseItemsRow.localTextPrefix; }
        protected form: PurchaseItemsForm;

        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = false;
            return opt;
        }

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables 
        public PartyId: number = 0;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public TransDate: Date;
        public DeptId: number;
        private NewLineNo: number;
        private GenSKU: boolean = false;
        public TotalItems: number;
        public isUpdate: number;
        public canUpdate: number;
        public MasterEntity: any;
        isEditable: boolean;

        // #endregion

        // #region Constructor
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true, showFooterRow: false, rowHeight: 30 });
            this.toolbar.findButton('add-button').find('.button-inner').text('New Product');
            let self = this;
             
            Q.reloadLookup(OMS.DepartmentMasterRow.lookupKey);
            var value = q.ToBool(GetConfigValue(1004)); 
            if (value == true)
                this.GenSKU = true;
            else
                this.GenSKU = false;

            this.isEditable = this.slickGrid.getOptions().editable;


            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as PurchaseMasterDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);
                }
            });

            this.slickGrid.onRender.subscribe(() => {
                // call of the function that will bind the editors with the fields (<input>) of the html page
                this.SetInlineLookupEditor();
            });
        }
        // #endregion

        // #region Column Add -Remove

        //enableFiltering() {
        //    return true;
        //}

        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this);
            var curr = new TabAurous.OMS.CurrencyFormatter;

            curr.currencyName = 'INR';

            var cur = ctx => curr.format(ctx);

            //var IsConsumed = this.ValidateStock();

            var Department = Q.first(columns, x => x.field === fld.DepartmentId);
            Department.referencedFields = [fld.DepartmentId];
            Department.format = ctx => {
                var width = (ctx.column.width) as number - 10;
                return '<input type="hidden" style="text-align: right; width:' + width + 'px;" id="LocId' + ctx.row + '" title="Location" />';
            };
            //Department.format = ctx => ColumnFormatter.selectFormatter(ctx, fld.DepartmentId, OMS.DepartmentMasterRow.getLookup(), this);

            Q.first(columns, x => x.field === fld.Pieces).format = ctx => {
                if (ctx.item.ItemTypeId != 104)
                    return this.isReadOnly == false ? ColumnFormatter.integerInputFormatter(ctx, this) : ColumnFormatter.ReadOnlyIntegerInput(ctx, this);
                else
                    return this.isReadOnly == false ? ctx.item.CategoryId != "7" ? ColumnFormatter.ReadOnlyIntegerInput(ctx, this) : ColumnFormatter.integerInputFormatter(ctx, this) : ColumnFormatter.ReadOnlyIntegerInput(ctx, this);
            }

            Q.first(columns, x => x.field === fld.Weight).format = ctx => {
                if (ctx.item.ItemTypeId == 101 && ctx.item.HasBom)
                    return ColumnFormatter.ReadOnlyWeightFormatter(ctx, this);
                else
                    return this.isReadOnly == false ? ColumnFormatter.WeightFormatter(ctx, this) : ColumnFormatter.ReadOnlyWeightFormatter(ctx, this);
            }

            Q.first(columns, x => x.field === fld.UnitRate).format = ctx => {
                if (ctx.item.ItemTypeId == 101 && ctx.item.HasBom)
                    return ColumnFormatter.ReadOnlyAmountFormatter(ctx, this);
                else
                    return this.isReadOnly == false ? ColumnFormatter.AmountFormatter(ctx, this): ColumnFormatter.ReadOnlyAmountFormatter(ctx, this);
            }

            Q.first(columns, x => x.field === fld.Discount).format = ctx => {
                    return this.isReadOnly == false ? ColumnFormatter.AmountFormatter(ctx, this) : ColumnFormatter.ReadOnlyAmountFormatter(ctx, this);
            }
            Q.first(columns, x => x.field === fld.DiscountPer).format = ctx => {
                return this.isReadOnly == false ? ColumnFormatter.numericInputFormatter(ctx, this) : ColumnFormatter.ReadonlynumericInputFormatter(ctx, this);
            }

            if (!this.GenSKU)
                columns = columns.filter(x => x.field != 'SKU');

            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }


        public SetInlineLookupEditor() {
            // course of all the lines present in the grid
            var Items = this.view.getItems();
            if (Items.length > 0)
                for (let Item in Items) {
                    this.InlineLookup(Item, Items);
                }
        }

        private InlineLookup(RowIndex: string, Items: PurchaseItemsRow[]) {

            var select = $("#LocId" + RowIndex);            

            if (!select.hasClass("select2-offscreen")) {

                let opt: Serenity.LookupEditorOptions = {
                    lookupKey: OMS.DepartmentMasterRow.lookupKey
                };
                var Editor = new TabAurous.InlineLookupEditor($("#LocId" + RowIndex), opt);
                if (this.isReadOnly == true) {
                    q.showAndDisableField(Editor);
                }
                
                Editor.value = Q.toId(Items[RowIndex].DepartmentId);
                Editor.changeSelect2(e => {
                    Items[RowIndex].DepartmentId = Q.toId(Editor.value);
                });
            }
            else {
                if (this.isReadOnly == false) {
                    select.closest('.slick-cell').find('.select2-container-disabled').removeClass('select2-container-disabled');
                    select.removeAttr("readonly");                 
                }
            }
        }

        // #endregion

        // #region Common Functions

        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }

        setMasterValues() {
            this.RateListId = (this.parentDialog as PurchaseMasterDialog).RateListId;
            this.LaborListId = (this.parentDialog as PurchaseMasterDialog).LaborMarkup;
            this.StoneMarkup = (this.parentDialog as PurchaseMasterDialog).StoneMarkup;
            this.StoneDiscount = (this.parentDialog as PurchaseMasterDialog).StoneDiscount;
            this.LaborMarkup = (this.parentDialog as PurchaseMasterDialog).LaborMarkup;
            this.LaborDiscount = (this.parentDialog as PurchaseMasterDialog).LaborDiscount;
            this.ExchangeRate = (this.parentDialog as PurchaseMasterDialog).ExchangeRate;
            this.TransDate = (this.parentDialog as PurchaseMasterDialog).form.TransDate.valueAsDate;
            this.PartyId = parseInt((this.parentDialog as PurchaseMasterDialog).form.PartyId.value) || 0;
        }

        public Editable() {
            this.isEditable = true;
        }


        // **** to Call shortcut key in Main Window


        // #endregion
         
        //#region  ItemGrid Inline Editor

        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            let Locked: boolean = false;

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;            

            // *** Validate Decimal & Integer***
            if (field === fld.Weight || field === fld.Discount || field === fld.UnitRate) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            if (field === fld.Pieces && value > 0 && item.ItemTypeId == 10) {
                q.Alert("Not Allowed", "Invalid Pieces", 2999, false);
                input.val(oldText);
                input.focus();
                return;                
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0 && item.ItemTypeId == 101) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.NetAmount * value;
                    item.Weight = (item.Weight / item.Pieces) * value;
                    item.DiamondPieces = (item.DiamondPieces / item.Pieces) * value;
                    item.DiamondWeight = (item.DiamondWeight / item.Pieces) * value;
                    item.DiamondAmount = (item.DiamondAmount / item.Pieces) * value;
                    item.StonePieces = (item.StonePieces / item.Pieces) * value;
                    item.StoneWeight = (item.StoneWeight / item.Pieces) * value;
                    item.StoneAmount = (item.StoneAmount / item.Pieces) * value;
                    item.OtherPieces = (item.OtherPieces / item.Pieces) * value;
                    item.OtherWeight = (item.OtherWeight / item.Pieces) * value;
                    item.OtherAmount = (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                }
                item[field] = value;
                item.LaborDetails.forEach(function (labor) {
                    labor.Pieces = value;
                })
            }
            // **** Allow to Set Pcs to Zero for RM ****
            if (field === fld.Pieces && item.ItemTypeId != 101) {
                if (item.CalcOnId == 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = ((item.UnitRate + labr) / item.Pieces) * value;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount
                    item.GrossAmount = Net - Discount;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                    item[field] = value;
                }
                else {
                    item[field] = value;
                }
                item.LaborDetails.forEach(function (labor) {
                    labor.Pieces = value;
                })

            }

            // **** Allow to Set Weight for RM ****
            if (field === fld.Weight && !item.HasBom) {
                if (item.CalcOnId != 3) {
                    var labr = item.UnitLabour || 0;
                    var rate = item.UnitRate || 0;
                    if (item.ItemTypeId == 101 || item.ItemTypeId == 104) {
                        rate = item.UnitRate * item.Purity;
                        item.PureWeight = value * item.Purity;
                    }

                    var Net = (rate + labr) * value;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount
                    item.GrossAmount = Net - Discount;
                    item.NetWeight = value;
                    if (item.WstPer != null) {
                        item.WstWt = value * (item.WstPer / 100);
                    }
                    item[field] = value;
                }
                else {
                    item[field] = value;
                }

                if (item.LaborDetails != null)
                    item.LaborDetails.forEach(function (labor) {
                        labor.Weight = value;
                    })
            }

            // **** Calculate Amount based on UnitRate and Weight or Pieces
            if (field === fld.UnitRate && item.ItemTypeId != 101) {
                if (item.CalcOnId != 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = (item.Weight * value) + labr;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;
                }


                if (item.CalcOnId == 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = (item.Pieces * value) + labr;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;
                }
                item[field] = value;
            }

            if (field === fld.UnitRate && item.ItemTypeId == 101 && item.HasBom == false) {
                if (item.CalcOnId != 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = (item.Weight * value) + labr;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;
                }


                if (item.CalcOnId == 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = (item.Pieces * value) + labr;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;
                }
                item[field] = value;
            }




            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item.DiscountPer = (value / item.NetAmount) * 100;
                item[field] = value;
            }

            // *** Calculate Discount % ***
            if (field === fld.DiscountPer && value >= 0) {
                var Discount = (item.NetAmount * value) / 100
                item.GrossAmount = item.NetAmount - Discount;
                item.Discount = Discount;
                item[field] = value;
            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;
            }

            item.CCGrossAmount = item.GrossAmount * this.ExchangeRate;
            item.CCNetAmount = item.NetAmount * this.ExchangeRate;

            this.view.updateItem(id, item);

            this.view.refresh();
            (this.parentDialog as PurchaseMasterDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion

        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons.filter(x => x.cssClass == "add-button")[0].visible = false;
            var addbutton = buttons.filter(x => x.cssClass == "add-button")[0];
            buttons.push({
                title: "New Product",
                cssClass: "add-button",
                hotkey: "alt+n",
                hint: 'alt+n',
                onClick: () => {
                    this.setMasterValues();
                    // **** Validate Party before Item Selection ****
                    if (this.PartyId == 0 || this.PartyId == null || isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;

                    }
                    else {

                        addbutton.onClick();
                    }

                }
            });
            //**** Master ****//
            buttons.push({
                title: "Select Items",
                cssClass: "stock-button",
                hotkey: "alt+k",
                hint:'alt+k',
                onClick: () => {
                    this.setMasterValues();
                    var self = this;
                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId) && this.PartyId == 0) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;
                    }
                    else {
                        var grid = Common.ProductSelectGrid;
                       
                        var filters: _Ext.SelectGridFilters = {
                            FilterItems: ItemSelection.JMS
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items", GridFilters: filters,
                            preSelectedKeys: this.value.map(k => k.ProductId)
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        //let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.AttributeId == t.AttributeId) });

                        let selectedItems2 = selectedItems;
                        var ItemDetails = ItemGridHelper.SetPurchaseItemGrid(selectedItems2, self.TransDate, self.PartyId, self.ExchangeRate, self.RateListId, self.LaborListId, self.LaborMarkup, self.GenSKU, true);
                        this.setData(ItemDetails);
                    }
                    pickerDialog.dialogOpen();
                },
                disabled: () => this.isReadOnly || this.readOnly
            });

            //**** POS Order ****//
            buttons.push({
                title: "Select POSOrders",
                cssClass: "order-button",
                hotkey: "alt+p",
                hint: 'alt+p',
                onClick: () => {
                    var grid = Retail.POSOrderItemsSelectGrid;
                    this.setMasterValues();
                    // **** Validate Party before Item Selection ****
                    if (this.PartyId == null) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;
                    }
                    else {
                        var filters: _Ext.SelectGridFilters = {
                            PartyId: this.PartyId,
                            InStock: false
                        }

                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true,
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var ItemDetails = ItemGridHelper.SetPurchaseItemGrid(selectedItems2, this.TransDate, this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup, this.GenSKU, true);
                        this.setData(ItemDetails);
                    }

                    pickerDialog.dialogOpen();
                }
            });

            //**** Purchase Order ****//
            buttons.push({
                title: "Select PO",
                cssClass: "order-button",
                hotkey: "alt+o",
                hint: 'alt+o',
                onClick: () => {
                    var grid = OrderForPurchaseGrid;
                    this.setMasterValues();

                    // **** Validate Party before Item Selection ****
                    if (this.PartyId == null) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;

                    }
                    else {
                        var filters: _Ext.SelectGridFilters = {
                            InStock: false
                        }

                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true,
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var ItemDetails = ItemGridHelper.SetPurchaseItemGrid(selectedItems2, this.TransDate, this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup, this.GenSKU, true);
                        this.setData(ItemDetails);
                    }
                    pickerDialog.dialogOpen();
                }
            });

            //**** Sales Order ****//
            buttons.push({
                title: "Select SO",
                cssClass: "order-button",
                hotkey: "alt+i",
                hint: 'alt+i',
                onClick: () => {
                    var grid = SalesOrder.OrderItemsForPurchaseGrid;
                    this.setMasterValues();
                    // **** Validate Party before Item Selection ****
                    if (this.PartyId == null) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;

                    }
                    else {
                        var filters: _Ext.SelectGridFilters = {
                            PartyId: this.PartyId,
                            InStock: false
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var ItemDetails = ItemGridHelper.SetPurchaseItemGrid(selectedItems2, this.TransDate, this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup, this.GenSKU, true);
                        this.setData(ItemDetails);

                    }
                    pickerDialog.dialogOpen();
                }
            });

            //**** Approval ****//
            buttons.push({
                title: "Select Approval",
                cssClass: "approval-button",
                hotkey: "alt+a",
                hint: 'alt+a',
                onClick: () => {
                    var grid = PurchaseApprovalGrid;
                    this.setMasterValues();
                    // **** Validate Party before Item Selection ****
                    if (this.PartyId == 0 || this.PartyId == null || this.PartyId == null) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;

                    }
                    else {
                        var filters: _Ext.SelectGridFilters = {
                            InStock: false,
                            PartyId: this.PartyId
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });

                        var ItemDetails = ItemGridHelper.SetPurchaseItemGrid(selectedItems2, this.TransDate, this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup, this.GenSKU, true);
                        this.setData(ItemDetails);
                        
                    }

                    pickerDialog.element.bind('dialogclose', () => {

                        this.element.trigger('dialogclose');

                    });
                    pickerDialog.dialogOpen();
                }
            });

            buttons.push(Serenity.ColumnPickerDialog.createToolButton(this as any));

            return buttons;
        }
        // #endregion

        // #region Set Data

        setData(ItemDetails: any[]) {
            if (this.view.getItems().length > 0) {
                this.TotalItems = ItemDetails.length + this.view.getItems().length;
            }
            else {
                this.TotalItems = ItemDetails.length;
            }
            for (let Itemdetail of ItemDetails) {
                Itemdetail[this.getIdProperty()] = "`" + this.nextId++;
                var x = Itemdetail;
                this.view.addItem(Itemdetail);
            }
        }    

        // #endregion

        ValidateStock() {
            let StockTrans;

            if (this.form.VoucherTypeId.value != null) {
                Stock.StockItemService.GetStockTransactions({
                    RefTransId: Q.parseInteger(this.form.TransId.value),
                    RefVoucherId: this.form.VoucherTypeId.value,
                    RefTransItemId: Q.parseInteger(this.form.TransItemId.value)
                },
                    response => StockTrans = response.Entities,
                    {
                        async: false
                    }
                );

            }

            if (StockTrans.length > 0)
                return true;
            else
                return false;
        }

        //protected onViewSubmit() {

        //    this.view.beginUpdate();

        //    let filter = function filter(item, args) {
        //        var linha = (item as PurchaseItemsRow);

        //        if (item["ProductCode"] == "3")
        //            return true;

        //        return false;
        //    }

        //    this.view.setFilter(filter);

        //    this.view.endUpdate();

        //    return true;
        //}

        protected createSlickGrid() {
            var grid = super.createSlickGrid();

            // need to register this plugin for grouping or you'll have errors
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('Pieces'),
                    new Slick.Aggregators.Sum('Weight'),
                    new Slick.Aggregators.Sum('GrossAmount'),
                ]
            });

            return grid;
        }
    }
}